const state = {
  fromid: -1,
  addArr: [],
  // 未读通知消息数量
  sysMessage: null,
  // 未读我的消息数量
  customMessage: null,
  // 清空首页消息缓存推送
  clearPush: false,
};
const mutations = {
  fromid(state, fromid) {
    state.fromid = fromid;
  },
  addArr(state, addArr) {
    state.addArr = addArr;
  },
  // 修改消息数量
  changeMessage(state, data) {
    state.sysMessage = data.sys_count;
    state.customMessage = data.custom_count;
  },
  // 修改清空状态
  setClearPush(state, bol) {
    state.clearPush = bol;
  },
};
const actions = {
  fromid: ({ commit }) => commit("fromid"),
  addArr: ({ commit }) => commit("addArr"),
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
